<div style="margin-top: -2rem">
  <div class="filter--checkboxes">
    <c11n-checkbox-group>
      <c11n-checkbox *ngFor="let label of productTypeFilters" [labelText]="filterMap[label]" [variant]="'default'" [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
        <input c11nCheckboxInput [id]="label" type="checkbox" name="choices" [value]="label" [formControl]="productTypeGroup.controls[label]"/>
      </c11n-checkbox>
    </c11n-checkbox-group>
  </div>
</div>

  <div *ngIf="isMutualFundsSelected" style=margin-bottom:24px>
    <b>Fund family</b>
    <div class="space">
      <br>{{fundFamilySelection}}<br>
    </div>
    <a href="javascript:void(0)" role="button" class="link" aria-label="Change Fund Family" (click)="detailViewModalDialog.openModalDialog($event);">Change</a>
  </div>

<c11n-modal-dialog
  #detailViewModalDialog
  [headingText]="'Fund family'"
  [primaryButtonLabel]="'Apply'"
  [secondaryButtonLabel]="'Cancel'"
  (closeEvent)="($event)"
  (closeSourceEvent)="($event)"
  (primaryClick)="applyButton($event)"
  (secondaryClick)="($event)"
>
  <div c11n-modal-dialog-body>
    <c11n-radio-group
      (stateChange)="getRadioButton($event)"
      [groupId]="'fundFamilies'"
      [legendText]="'Select a fund family'"
      [hideLegend]="true"
    >
    <hr aria-hidden="true">
      <c11n-radio
        labelText="Vanguard"
        descriptiveLabel="'Vanguard'"
      >
        <input
          c11nRadioInput
          id="vanguard"
          type="radio"
          name="choices"
          value="choice1"
          [checked]="fundFamilySelection === 'Vanguard'"
        />
      </c11n-radio>
      <hr aria-hidden="true">
      <c11n-radio *ngFor="let family of fundFamilyDetails"
                  [labelText]="family.fundFamilyName + (family.hasLoadFunds ? ' [Load]' : '') +
                  (family.hasNTFFunds ? ' [NTF]' : '')">
        <input
          c11nRadioInput
          [id]="family.fundFamilyId"
          type="radio"
          name="choices"
          [value]="family.fundFamilyId"
          [checked]="fundFamilySelection === family.fundFamilyName + (family.hasLoadFunds ? ' [Load]' : '') +
                  (family.hasNTFFunds ? ' [NTF]' : '')"
        />
      </c11n-radio>
    </c11n-radio-group>
  </div>
</c11n-modal-dialog>
